import {API} from './apiWrapper'

export const S3Read:any = () => {
    const get = async (s3key:any, level:any) => {
        //as3key: public/2022/7/us-east-1:1846f641-bdac-468c-996c-6bd95f44b03e/school.testnewemailone.1661275930367/submit/1661276125047
        //console.log('get not implemented: ' + s3key + ":" + JSON.stringify(level));
        //get pre-signed URL for single S3 Object.
        return await API.post('S3Read', 'save?key=presign', {s3key: s3key, level: level});
    }

    const list = async (as3key:any, body:any) => {
        //console.log('list not implemented: ' + as3key + ":" + JSON.stringify(body));
        let response = await API.post('S3Read', 'save?key=list', {year: as3key});
        let fileOnly = [];
        if (response) {
            fileOnly = response.filter((fileMeta:any)=>{
                return fileMeta.Size > 0;
            });
        }
        return fileOnly;
    }
    return {
        get,
        list
    };
};

export const Storage = S3Read();